export const firebaseConfig = {
  apiKey: "AIzaSyDTj8AzeFsnBy0RKdmNmURSF3Egnde-Qiw",
  authDomain: "cloudregistration.firebaseapp.com",
  databaseURL: "https://cloudregistration.firebaseio.com",
  projectId: "cloudregistration",
  storageBucket: "cloudregistration.appspot.com",
  messagingSenderId: "108785185665",
  appId: "1:108785185665:web:78b773e90d5de29e5bee80"
};